import appendSlide from './appendSlide';
import prependSlide from './prependSlide';
import addSlide from './addSlide';
import removeSlide from './removeSlide';
import removeAllSlides from './removeAllSlides';

export default {
  appendSlide,
  prependSlide,
  addSlide,
  removeSlide,
  removeAllSlides,
};



// WEBPACK FOOTER //
// ./node_modules/framework7/components/swiper/swiper-class/components/core/manipulation/index.js